<script lang="ts">
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';
    import { Navigation } from '../../utilities/Navigation';
    import { onMount } from 'svelte';

    import IconRemove from '../../shared/Icons/IconRemove.svelte';
    // import {currentMap} from "../../../stores/api";
    import { api } from '../../../stores/api';
    import { MapApi } from './MapApi';
    import { mainMenu } from '../../../stores/store';
    import type { MapType } from './types';
    import { filter } from '../../../stores/filter';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import MessageFiltered from '../../shared/MessageFiltered.svelte';
    import { ZoneApi } from '../Zones/ZoneApi';

    let filteredMaps: MapType[] = [];
    let error: string = '';
    let loading: boolean = true;
    let maps: MapType[] = [];

    function onRemoveMap(map_id: number) {
        ZoneApi.removeAllByMapId(get(api), map_id)
            .then(() => {
                MapApi.removeOne(get(api), map_id)
                    .then(() => {
                        maps = maps.filter(w => w.id !== map_id);
                        error = '';
                    })
                    .catch(e => {
                        error = e;
                    });
            })
            .catch(e => {
                error = e;
            });
    }

    function editMap(map_id: number) {
        MapApi.getOne(get(api), map_id).then(map => {
            Navigation.navigate('/map/' + map.id);
        });
    }

    // function createMap() {
    //     currentMap.set(-1);
    //     Navigation.navigate('/map/new');
    // }

    function selectCurrentMap(map_id: number) {
        alert('Not implemented yet');
    }

    function filterByQuery(query: string) {
        filteredMaps = maps.filter(
            w => query === '' || w.name.toLowerCase().includes(query.toLowerCase())
        );
    }

    onMount(() => {
        $mainMenu.currentPage = 'PageMaps';
        MapApi.getAll(get(api))
            .then(response => {
                maps = response;
                filteredMaps = response;
            })
            .catch(e => {
                maps = [];
                filteredMaps = [];
                error = e;
            })
            .finally(() => {
                loading = false;
            });

        return () => {
            maps = [];
            filteredMaps = [];
        };
    });

    $: {
        filteredMaps = [...maps];
        filterByQuery($filter.maps.query);
    }
</script>

{#if loading}
    <Spinner />
{:else}
    {#if error}
        <MessageDanger {error} />
    {/if}
    {#if filteredMaps.length === 0 && maps.length > 0}
        <h3>{$_('not_found_any_items_change_filter_settings')}</h3>
    {:else}
        {#if maps.length > 0}
            <MessageFiltered filteredCount={filteredMaps.length} totalCount={maps.length} />
        {/if}
        <div style="margin-top: 30px;">
            <div class="map-row map-header">
                <div class="map-selector">
                    <!--                    Active-->
                </div>
                <div class="map-name">Name</div>
                <div class="map-zones">Zones</div>
                <div class="map-remove">Remove</div>
            </div>
            {#each filteredMaps as map}
                <div class="map-row map-data">
                    <div class="map-selector" title="Select current map">
                        <!--                        <input type="radio" checked={$currentMap===map.id} value={map.id} name="map_id" on:change={()=>{selectCurrentMap(map.id)}}>-->
                    </div>
                    <div
                        class="map-name"
                        on:click={() => {
                            editMap(map.id);
                        }}
                    >
                        {map.name}
                    </div>
                    <div class="map-zones">0</div>
                    <div class="map-remove" title="Remove map">
                        <IconRemove
                            on:click={() => {
                                onRemoveMap(map.id);
                            }}
                        />
                    </div>
                </div>
            {/each}
        </div>
        <!--        <ButtonMain text="New map" showIcon={false} on:click={createMap}/>-->
    {/if}
{/if}

<style>
    .map-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-size: 14px;
    }
    .map-data {
        min-height: 40px;
    }
    .map-header,
    .map-data {
        border-bottom: 1px solid #9994;
    }
    .map-header {
        font-size: 12px;
        padding-bottom: 4px;
    }

    .map-header > div {
        opacity: 0.5;
    }

    .map-selector {
        /*width: 2%;*/
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .map-name {
        width: 50%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .map-data .map-name {
        height: 40px;
    }

    .map-zones {
        width: 15%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .map-remove {
        width: 15%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .map-data:hover {
        cursor: pointer;
        background-color: var(--main-selected-background);
        transition: 0.2s;
        border-radius: 1px;
    }
    .map-data .map-remove {
        transform: scale(0.7);
    }
</style>
